import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { readSheetNames } from 'read-excel-file';
import { DirectSaleProgramService } from 'src/app/application/service/DirectSaleProgramService';
import { formatUrl } from 'src/app/ui/util/file-formats';

@Component({
  selector: 'app-admin-uploads',
  templateUrl: './admin-uploads.component.html',
  styleUrls: ['./admin-uploads.component.css'],
    providers: [ConfirmationService]
})
export class AdminUploadsComponent {


  excelFile: any
  excelSheets: any
  selectedSheet: string = ''
  loading: boolean = false
  uploadFile: any[] = []
  uploadFormatUrl: string = formatUrl.program_pallet_format
  uploadDisabled: boolean = true

  constructor(
    private _messageService: MessageService,
    private translate: TranslateService,
    private _directSaleService: DirectSaleProgramService
  ){

  }


  sendFiles() {
    this.loading = true
    if (this.uploadFile[0]) {
      const request: any = {
        file: this.uploadFile[0]
      }

      this._directSaleService.uploadOrdersProgram(request).subscribe({
        next: (v) => {
          this._messageService.add({ severity: 'success',
            summary: this.translate.instant('MessageService.Summary.SuccessAction'),
            detail: 'Pallets cargados exitosamente' })
            this.loading = false
        },
        error: (e) => {
          this.loading = false
          let errorMessage = ''
            const lang = this.translate.currentLang
            switch(lang) {
              case 'es':
                errorMessage = e.error.messageEs
                break
              case 'en':
                errorMessage = e.error.messageEn
                break
              default:
                errorMessage = 'Error a cargar pallets'
            }
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: errorMessage })
        },
        complete: () => console.info('Program request created successfully')
      })
    }else{

      this._messageService.add({ severity: 'error',
        summary: this.translate.instant('MessageService.Summary.FailedAction'),
        detail: this.translate.instant('MessageService.FailFileAction')
       })
      this.loading = false
    }
  }

  onSelect(event: any, uploader: any){
    this.uploadFile = uploader.files
    if(this.uploadFile.length > 0){
      this.uploadDisabled = false;
    }else{
      this.uploadDisabled = true;
    }
  }

  onRemove(event: any, uploader: any) {
    this.uploadFile = uploader.files
    if(this.uploadFile.length > 0){
      this.uploadDisabled = false;
    }else{
      this.uploadDisabled = true;
    }
  }

  onClear(event: any, uploader: any) {
    this.uploadFile = uploader.files
    if(this.uploadFile.length > 0){
      this.uploadDisabled = false;
    }else{
      this.uploadDisabled = true;
    }
  }
}
